import React, {useEffect, useState} from 'react'
import {Row, Col} from 'react-bootstrap'
import {State} from 'country-state-city'
import '../../agent.scss'
import Dropdown from '../../../../sharedComponent/Dropdown/Dropdown'
import GooglePlaceAutocomplete from '../../../../sharedComponent/GooglePlaceAutoComplete/GooglePlaceAutocomplete'
interface Props {
  formik: any
  isServiceSameAsBill: any
  hasFieldError: boolean
  billingRef: any
  featureFlags: any
}

const BillingAddressInfo = ({
  formik,
  isServiceSameAsBill,
  hasFieldError,
  billingRef,
  featureFlags,
}: Props) => {

  const [state, setState] = useState<any>()
  useEffect(() => {
    const getAllStates = State.getStatesOfCountry('US')
    setState(getAllStates.map((eachState) => ({id: eachState.isoCode, value: eachState.name})))

  }, [])


  const handleSelectedItem = (e: any, name: any) => {
    if (e.value.length > 0) {
      formik.setFieldValue(name, e.label)
      formik.setFieldValue(`${name}Id`, e.value)
    } else {
      formik.setFieldValue(name, '')
      formik.setFieldValue(`${name}Id`, null)
    }
  }

  return (
    <>
      <div className='fv-row mb-4 mt-2'>
        <label className='d-flex align-items-center mb-2 required'>
          <span className='fs-6 fw-semibold'>Address Line 1</span>
        </label>
        {isServiceSameAsBill ||
        !featureFlags?.getClientFeatureFlags?.isGoogleSearchAheadRequired ? (
          <input
            id='billingAddress'
            ref={billingRef}
            type='text'
            className='form-control form-control-lg form-control-solid'
            name='billingAddress'
            placeholder='Enter Address'
            readOnly={isServiceSameAsBill}
            {...(isServiceSameAsBill
              ? {...formik.getFieldProps('serviceAddress')}
              : {...formik.getFieldProps('billingAddress')})}
          />
        ) : (
          <GooglePlaceAutocomplete
            formik={formik}
            fieldName='billingAddress'
            ref={billingRef}
            zipcodeFieldName='billingZipCode'
            cityFieldName='billingCity'
            stateFieldName='billingState'
            addressFieldName="address"
          />
        )}

        {!isServiceSameAsBill && formik.errors.billingAddress  && hasFieldError && (
          <div className='fv-plugins-message-container'>
            <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
              {formik.errors.billingAddress}
            </div>
          </div>
        )}
      </div>
      <div className='fv-row mb-2'>
        <label className='d-flex align-items-center mb-2'>
          <span className='fs-6 fw-semibold'>Address Line 2</span>
        </label>
        <input
          type='text'
          id='billingAddress2'
          className='form-control form-control-lg form-control-solid'
          name='billingAddress2'
          placeholder='Enter Unit, Suite, Floor, Building, etc'
          readOnly={isServiceSameAsBill}
          maxLength={231}
          {...(isServiceSameAsBill
            ? {...formik.getFieldProps('serviceAddress2')}
            : {...formik.getFieldProps('billingAddress2')})}
        />
      </div>
      <Row className='mb-2 d-flex align-items-end noPadding'>
        <Col sm={6} md={6} className='pb-5'>
          <label className='d-flex align-items-center mb-2 required'>
            <span className='fs-6 fw-semibold lh-23px'>Country</span>
          </label>
          <select
            className='form-select form-select-solid'
            aria-label='Select example'
            name='billingCountry'
            disabled={isServiceSameAsBill}
            value='US'
            {...(isServiceSameAsBill
              ? {...formik.getFieldProps('serviceCountry')}
              : {...formik.getFieldProps('billingCountry')})}
          >
            <option>US</option>
          </select>
        </Col>
        <Col sm={6} md={6} className='pb-5'>
          <label className='d-flex align-items-center mb-2 required '>
            <span className='fs-6 fw-semibold lh-23px'>State</span>
          </label>
          <Dropdown
            fieldName={isServiceSameAsBill ? 'serviceState' : 'billingState'}
            optionList={state}
            handleSelectedItem={handleSelectedItem}
            formik={formik}
            fieldDisabled={isServiceSameAsBill}
          />
        </Col>
      </Row>
      <Row className='mb-2 d-flex align-items-end noPadding'>
        <Col sm={6} md={6} className='pb-5'>
          <label className='d-flex align-items-center mb-2 required'>
            <span className='fs-6 fw-semibold lh-23px'>City</span>
          </label>
          <input
            id='billingCity'
            type='text'
            className='form-control form-control-lg form-control-solid'
            readOnly={isServiceSameAsBill}
            name='billingCity'
            placeholder='Select City'
            maxLength={51}
            {...(isServiceSameAsBill
              ? {...formik.getFieldProps('serviceCity')}
              : {...formik.getFieldProps('billingCity')})}
          />
          {!isServiceSameAsBill && formik.errors.billingCity && hasFieldError && (
            <div className='fv-plugins-message-container'>
              <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                {formik.errors.billingCity}
              </div>
            </div>
          )}
        </Col>
        <Col sm={6} md={6} className='pb-5'>
          <label className='d-flex align-items-center mb-2 required'>
            <span className='fs-6 fw-semibold lh-23px'>Zip Code</span>
          </label>
          <input
            type='text'
            id='billingZipCode'
            className='form-control form-control-lg form-control-solid'
            readOnly={isServiceSameAsBill}
            name='billingZipCode'
            placeholder='Enter zipcode'
            maxLength={5}
            {...(isServiceSameAsBill
              ? {...formik.getFieldProps('serviceZipCode')}
              : {...formik.getFieldProps('billingZipCode')})}
          />
          {!isServiceSameAsBill && formik.errors.billingZipCode && hasFieldError && (
            <div className='fv-plugins-message-container'>
              <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                {formik.errors.billingZipCode}
              </div>
            </div>
          )}
        </Col>
      </Row>
    </>
  )
}

export default BillingAddressInfo
